import React, { useState, useEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext';

// Mapping of emoji to icon file names
const EMOJI_TO_ICON = {
  '📸': 'camera',
  '📷': 'camera',
  '✉️': 'envelope',
  '📊': 'chart',
  '⏰': 'clock',
  '🕒': 'clock',
  '⚡': 'lightning',
  '📋': 'clipboard',
  '⚠️': 'warning',
  '✓': 'checkmark',
  '✅': 'checkmark',
  '👤': 'person',
  '💼': 'briefcase',
  '🏢': 'building',
  '📧': 'email',
  '📞': 'phone',
  '📍': 'location',
  '🌐': 'globe',
  '🎪': 'calendar',
  '🏭': 'factory',
  '📝': 'note',
  '✏️': 'pencil',
  '💾': 'floppy',
  '❌': 'x',
  '🔍': 'search',
  '🚪': 'door',
  '☰': 'hamburger',
  '☀️': 'sun',
  '🌙': 'moon',
  '🔗': 'link',
  '💡': 'lightbulb',
  '🗑️': 'delete',
  '💎': 'diamond',
  '⬇️': 'arrow-down',
  '⬆️': 'arrow-up',
};

/**
 * Icon component that loads custom SVG icons with fallback to emoji
 * @param {string} emoji - The emoji to display as fallback
 * @param {string} name - Optional icon name (if different from emoji mapping)
 * @param {string} className - Additional CSS classes
 * @param {string} size - Size class (text-xs, text-sm, text-base, text-lg, text-xl, text-2xl, etc.)
 */
function Icon({ emoji, name, className = '', size = 'text-base' }) {
  const { isDark } = useTheme();
  const [iconError, setIconError] = useState(false);
  const [iconPath, setIconPath] = useState(null);

  useEffect(() => {
    // Determine icon name
    const iconName = name || EMOJI_TO_ICON[emoji];
    
    if (!iconName) {
      setIconError(true);
      return;
    }

    // Determine which folder to use based on theme
    const themeFolder = isDark ? 'dark' : 'light';
    const path = `/icons/${themeFolder}/${iconName}.svg`;
    setIconPath(path);
    setIconError(false);
  }, [emoji, name, isDark]);

  // If no icon name found or error loading, fallback to emoji
  if (iconError || !iconPath) {
    return <span className={`inline-block ${size} ${className}`}>{emoji}</span>;
  }

  return (
    <img
      src={iconPath}
      alt=""
      className={`inline-block ${size} ${className}`}
      onError={() => setIconError(true)}
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
    />
  );
}

export default Icon;

